import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
    Button,
    TableCell,
    TableRow,
} from "@material-ui/core";
import { ModalGestionarEstudio } from "./Modal/ModalGestionarEstudio";
import { FetchDataAfiliado, FetchDataAfiliadoExterno, setEstudioMedicos } from "../../../actions/turnos/estudiosMedicos";
import { OBRAS_SOCIALES } from "../../../utils/constants";
import { ModalHistorialCambios } from "./Modal/ModalHistorialCambios";
import InfoHistorialIcon from "../../autorizaciones/UI/InfoHistorialIcon";

const useRowStyles = makeStyles({
    root: {
        "& > *": {
            borderBottom: "unset",
        },
    },
});

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const EstudiosMedicosItem = (props) => {

    const dispatch = useDispatch();
    const { item } = props;
    const [openModalGestionar, setOpenModalGestionar] = useState(false);
    const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);
    const classes = useRowStyles();

    return (
        <>
            {openModalGestionar && (
                <ModalGestionarEstudio
                    open={openModalGestionar}
                    closeModalHandler={() => {
                        setOpenModalGestionar(false);
                    }}
                    //postRetomarReceta={postRetomarReceta}
                    setOpenModalGestionar={setOpenModalGestionar}
                    filtros={props.filtros}
                />
            )}
            {openModalHistorialCambios && (
                <ModalHistorialCambios
                    open={openModalHistorialCambios}
                    closeModalHandler={() => {
                        setOpenModalHistorialCambios(false);
                    }}
                    item={item}
                    titulo={`Estudio Medico N° ${item.id}`}
                />
            )}
            <TableRow className={classes.root} >
                <TableCell align="center" sx={{ padding: "10px" }}>
                    <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
                </TableCell>
                <TableCell align="left">{new Date(item.fechaCarga).toLocaleString("es", optionsfecha)} </TableCell>
                <TableCell align="left">{item.id}</TableCell>
                <TableCell align="left">{item.nomApeAfiliado}</TableCell>
                <TableCell align="left">{item.carnet}</TableCell>
                <TableCell align="left">{item.descripcionCentroMedico}</TableCell>
                <TableCell align="left">{item.nombreMedico}</TableCell>
                <TableCell>{item.descripcionEspecialidad}</TableCell>
                <TableCell align="left">{item.descripcionEstudio}</TableCell>
                <TableCell align="left">{item.descripcionProblema}</TableCell>
                <TableCell>
                    <Button
                        style={{ fontSize: "0.8rem" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpenModalGestionar(true);
                            dispatch(setEstudioMedicos(item));
                            if (item?.idAfiliado) {
                                dispatch(FetchDataAfiliado(item.idAfiliado));
                            }
                            else {
                                dispatch(FetchDataAfiliadoExterno(OBRAS_SOCIALES.OSOCNA, item.nroDocumento))
                            }
                        }}
                    >
                        GESTIONAR
                    </Button>
                </TableCell>
            </TableRow>
        </>
    )
}
